import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UpdateCityAttributeComponent } from './update-city-attribute/update-city-attribute.component';

const routes: Routes = [
  {
    path: '',
    component: UpdateCityAttributeComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CityAttributeRoutingModule {}
